import api from '@/lib/api';
import { RoleRequest, RoleResponse } from '@/types/api';

export const roleService = {
  // Listar todas as roles
  async getRoles(): Promise<RoleResponse[]> {
    const response = await api.get<RoleResponse[]>('/roles');
    return response.data;
  },

  // Buscar role por ID
  async getRoleById(id: string): Promise<RoleResponse> {
    const response = await api.get<RoleResponse>(`/roles/${id}`);
    return response.data;
  },

  // Criar nova role
  async createRole(roleData: RoleRequest): Promise<RoleResponse> {
    const response = await api.post<RoleResponse>('/roles', roleData);
    return response.data;
  },

  // Atualizar role
  async updateRole(id: string, roleData: RoleRequest): Promise<RoleResponse> {
    const response = await api.put<RoleResponse>(`/roles/${id}`, roleData);
    return response.data;
  },

  // Deletar role
  async deleteRole(id: string): Promise<void> {
    await api.delete(`/roles/${id}`);
  },
};
